import { HistoryFiltersDirection, HistoryFiltersType } from "@/types/balances"

import type { Option } from "@/ui/components/Dropdown"

export const directionFilterOptions: Option[] = [
  {
    value: HistoryFiltersDirection.All,
    label: "Все"
  },
  {
    value: HistoryFiltersDirection.Incoming,
    label: "Входящие"
  },
  {
    value: HistoryFiltersDirection.Outgoing,
    label: "Исходящие"
  }
]

export const typeFilterOptions: Option[] = [
  {
    value: HistoryFiltersType.All,
    label: "Все"
  },
  {
    value: HistoryFiltersType.Rep,
    label: "Replenishment"
  },
  {
    value: HistoryFiltersType.Xch,
    label: "Exchange currency"
  },
  {
    value: HistoryFiltersType.Trsf,
    label: "Internation transfer money"
  },
  {
    value: HistoryFiltersType.Cmm,
    label: "Bank comission"
  },
  {
    value: HistoryFiltersType.Exps,
    label: "Company expenses"
  },
  {
    value: HistoryFiltersType.Rfnd,
    label: "Refund"
  },
  {
    value: HistoryFiltersType.Dep,
    label: "Interest rates on deposits"
  }
]
